var map = {
	"./de_DE.json": 765,
	"./en_AU.json": 766,
	"./en_CA.json": 767,
	"./en_GB.json": 768,
	"./es_AR.json": 769,
	"./es_ES.json": 770,
	"./es_MX.json": 771,
	"./fr_CA.json": 772,
	"./fr_FR.json": 773,
	"./it_IT.json": 774,
	"./nl_NL.json": 775,
	"./pt_BR.json": 776,
	"./pt_PT.json": 777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;